<span
  class="ctx-table__toolbar flex flex-row items-center justify-between gap-x-4 py-2 px-5 overflow-auto border-b rounded-t-xs"
>
  <!-- Buttons -->
  <span class="flex flex-row items-center gap-x-4">
    <button
      size="base"
      ctx-button--secondary
      actionIcon="REFRESH"
      color="accent"
      [disabled]="!!(resourceTableService.tableLoading$ | async)"
      (click)="resourceTableService.tableList()"
    ></button>
    @if (resourceTableService.actions.create && !isSelected) {
    <button
      size="base"
      ctx-button--secondary
      actionIcon="CREATE"
      (click)="
        authn.isTrialExpired
          ? TrialExpireService.toggleBlockPortalAccess()
          : resourceTableService.launchCreationDialog()
      "
      [disabled]="!resourceTableService.createAllowed"
    >
      {{ creationLabel }}
    </button>
    } @if (resourceTableService.actions.delete && isSelected) {
    <button
      size="base"
      ctx-button--secondary
      actionIcon="DELETE"
      [disabled]="resourceTableService.selections.isEmpty()"
      color="warn"
      (click)="resourceTableService.launchDeletionDialog()"
      [disabled]="!resourceTableService.deleteAllowed"
    >
      Delete
    </button>
    } @if (resourceTableService.actions.tag && isSelected) {
    <button
      size="base"
      ctx-button--secondary
      actionIcon="TAG"
      color="accent"
      (click)="
        authn.isTrialExpired
          ? TrialExpireService.toggleBlockPortalAccess()
          : resourceTableService.launchTagPicker(
              resourceTableService.selections.selected
            )
      "
      [disabled]="
        !resourceTableService.writeAllowed ||
        !resourceTableService.permissionsService.allowedAction('tag', 'read')
      "
    >
      Tag
    </button>
    }
    <!-- TODO -->
    @if ( resourceTableService.actions.customToolbarActions &&
    resourceTableService.actions.customToolbarActions.length > 0 ) { @for
    (action of resourceTableService.actions.customToolbarActions; track action)
    { @if ( (isSelected && action.isBulkOperation) || (!action.isBulkOperation
    && !isSelected) ) {
    <button
      size="base"
      [actionIcon]="action.actionIcon"
      ctx-button--secondary
      [color]="action.color"
      (click)="
        authn.isTrialExpired
          ? TrialExpireService.toggleBlockPortalAccess()
          : callCustomAction(action)
      "
      [disabled]="action?.disabled()"
    >
      {{ action.label }}
    </button>
    } } } @if ( resourceTableService.actions.export &&
    resourceTableService.dataSource.value.length !== 0 && !isSelected ) {
    <button
      size="base"
      ctx-button--secondary
      actionIcon="DOWNLOAD"
      color="accent"
      [disabled]="
        resourceTableService.dataSource.value.length === 0 ||
        !resourceTableService.readAllowed
      "
      (click)="
        authn.isTrialExpired
          ? TrialExpireService.toggleBlockPortalAccess()
          : resourceTableService.launchExportDialog()
      "
    >
      Export
    </button>
    }
  </span>

  <!-- Search -->
  <span class="flex flex-row ml-2 w-72">
    @if (resourceTableService.actions.search) {
    <mat-form-field class="mat-mdc-form-field--xs flex-grow text-xs">
      <hlm-icon class="mx-2" name="SEARCH" matPrefix inline></hlm-icon>
      <input
        matInput
        autocomplete="off"
        type="search"
        [formControl]="searchControl"
        [placeholder]="resourceTableService.tableSearchPlaceholder"
        (input)="search()"
      />
    </mat-form-field>
    }
  </span>
</span>
